import { cn } from "@/lib/utils";
import { SIDEBAR_NAV_IDS } from "./Sidebar";

const LABELS: Record<string, string> = {
  insighturi: "Insighturi",
  "cost-productie": "Cost producție",
  "media-mobila": "Media mobilă",
  profitabilitate: "Profitabilitate",
  masini: "Mașini & operatori",
  export: "Export vs. intern",
  "top-clienti": "Top clienți",
  "mix-sezonalitate": "Mix & sezonalitate",
  pierderi: "Pierderi / waste",
  livrari: "Livrări",
};

interface MobileNavProps {
  activeId: string;
  onNavigate: (id: string) => void;
}

/** Nav orizontal, scrollabil, vizibil doar sub breakpoint-ul lg (sidebar-ul e ascuns pe mobil). */
export function MobileNav({ activeId, onNavigate }: MobileNavProps) {
  return (
    <div className="lg:hidden sticky top-0 z-10 flex gap-2 overflow-x-auto border-b border-slate-200 bg-white/95 px-4 py-2 backdrop-blur scrollbar-thin">
      {SIDEBAR_NAV_IDS.map((id) => (
        <button
          key={id}
          onClick={() => onNavigate(id)}
          className={cn(
            "shrink-0 rounded-full px-3 py-1.5 text-xs font-medium transition-colors",
            activeId === id
              ? "bg-brand-600 text-white"
              : "bg-slate-100 text-slate-600 hover:bg-slate-200",
          )}
        >
          {LABELS[id]}
        </button>
      ))}
    </div>
  );
}
